import { globalStyles } from 'theme';
import { stripTags } from 'utils/html';

const renderAmpPage = ({
  title,
  styles,
  body,
  description,
  canonicalUrl,
  altUrls,
  ampTrackingId,
  ampSchemaMarkup,
}: {
  title: string;
  styles: string;
  body: string;
  description?: string;
  canonicalUrl?: string;
  altUrls?: [
    {
      url: string;
      locale: string;
    }
  ];
  ampTrackingId: string;
  ampSchemaMarkup?: string;
}) => `
<!DOCTYPE html>
<html lang="${USER_LOCALE}" ⚡>
<head>
  <meta charset="utf-8">
  <meta name="viewport" content="width=device-width, initial-scale=1, minimum-scale=1, shrink-to-fit=no">
  <style amp-boilerplate>body{-webkit-animation:-amp-start 8s steps(1,end) 0s 1 normal both;-moz-animation:-amp-start 8s steps(1,end) 0s 1 normal both;-ms-animation:-amp-start 8s steps(1,end) 0s 1 normal both;animation:-amp-start 8s steps(1,end) 0s 1 normal both}@-webkit-keyframes -amp-start{from{visibility:hidden}to{visibility:visible}}@-moz-keyframes -amp-start{from{visibility:hidden}to{visibility:visible}}@-ms-keyframes -amp-start{from{visibility:hidden}to{visibility:visible}}@-o-keyframes -amp-start{from{visibility:hidden}to{visibility:visible}}@keyframes -amp-start{from{visibility:hidden}to{visibility:visible}}</style><noscript><style amp-boilerplate>body{-webkit-animation:none;-moz-animation:none;-ms-animation:none;animation:none}</style></noscript>
  <script async src="https://cdn.ampproject.org/v0.js"></script>
  <script async custom-element="amp-analytics" src="https://cdn.ampproject.org/v0/amp-analytics-0.1.js"></script>
  <script async custom-element="amp-vimeo" src="https://cdn.ampproject.org/v0/amp-vimeo-0.1.js"></script>
  <script async custom-element="amp-youtube" src="https://cdn.ampproject.org/v0/amp-youtube-0.1.js"></script>
  <script async custom-element="amp-list" src="https://cdn.ampproject.org/v0/amp-list-0.1.js"></script>
  <script async custom-template="amp-mustache" src="https://cdn.ampproject.org/v0/amp-mustache-0.2.js"></script>
  <script async custom-element="amp-form" src="https://cdn.ampproject.org/v0/amp-form-0.1.js"></script>
  <link rel="apple-touch-icon" sizes="180x180" href="/apple-touch-icon.png">
  <link rel="icon" type="image/png" sizes="32x32" href="/favicon-32x32.png">
  <link rel="icon" type="image/png" sizes="16x16" href="/favicon-16x16.png">
  <link rel="manifest" href="/manifest.json">
  <link rel="mask-icon" href="/safari-pinned-tab.svg" color="#0275d8">
  <link rel="shortcut icon" href="/favicon.ico?version=GvkNLMOvjL">
  <meta name="apple-mobile-web-app-title" content="Idealist">
  <meta name="application-name" content="Idealist">
  <meta name="theme-color" content="#ffffff">
  <title>${title} - Idealist</title>
  <link href="https://fonts.googleapis.com/css?family=Source+Sans+Pro:400,400i,600,600i,700" rel="stylesheet">
  ${
    description
      ? `
    <meta name="description" content="${stripTags(
      description.slice(0, 200)
    ).replace(/"/g, "'")}" />
  `
      : ''
  }
  ${
    canonicalUrl
      ? `
    <link rel="canonical" href="${canonicalUrl}">
  `
      : ''
  }
  ${
    altUrls
      ? altUrls
          .map(
            ({ url, locale }) => `
    <link rel="alternate" href="${url}" hreflang="${locale}" >
  `
          )
          .join('\n')
      : ''
  }
  ${
    ampSchemaMarkup
      ? `
      <script type="application/ld+json">${ampSchemaMarkup}</script>
  `
      : ''
  }
  <style amp-custom>
    ${globalStyles}
    ${styles}
  </style>
</head>
<body>
  <amp-analytics
    config="https://www.googletagmanager.com/amp.json?id=${ampTrackingId}&gtm.url=SOURCE_URL"
    data-credentials="include"
  ></amp-analytics>
  ${body}
</body>
</html>
`;

export default renderAmpPage;
